<template>
  <base-page
    :title="'Edit Invoice'"
  >
    <template #actionButton>
      <v-menu
        v-if="!_isEmpty(invoice)"
        left>
        <template v-slot:activator="{ on }">
          <v-btn
            rounded
            outlined
            color="primary"
            v-on="on"
          >
            Actions

            <v-icon>more_vert</v-icon>
          </v-btn>
        </template>

        <v-list dense>
          <v-list-item @click="confirmFinalize = true">
            <v-list-item-content>
              <v-list-item-title>
                <v-icon left small>check_circle_outline</v-icon>
                Finalize
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>


          <v-list-item
            @click="confirmDeleteDraft = true"
          >
            <v-list-item-content>
              <v-list-item-title class="error--text">
                <v-icon left small color="error">delete</v-icon>
                Delete draft
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>

      <confirm-action
        :model="confirmDeleteDraft"
        :color="'error'"
        :title="'Delete Draft Invoice'"
        :description="'Are you sure you want to permanently delete this draft invoice?<br>\n'+
'          <br>\n'+
'          <b>This can\'t be undone.</b>'"
        :action-text="'Delete'"
        @cancel="confirmDeleteDraft = false"
        @confirmed="confirmedDeleteDraft"
      />

      <confirm-action
        :model="confirmFinalize"
        :color="'info'"
        :title="'Finalize Invoice'"
        :description="'Once an invoice has been finalized, it cannot be modified.'"
        :action-text="'Finalize'"
        @cancel="confirmFinalize = false"
        @confirmed="confirmedFinalize"
      />
    </template>

    <template #main>
      <v-row
        v-if="isLoading"
        align="center"
        justify="center"
      >
        <v-progress-circular
          :size="125"
          :width="7"
          color="primary"
          indeterminate
        />
      </v-row>
      <invoice-form
        v-if="!isLoading && invoice"
        :invoice="invoice"
      />
    </template>
  </base-page>
</template>
<script>
import BasePage from '@/views/BasePage.vue'
import InvoiceForm from "../../components/Invoice/InvoiceForm"
import ConfirmAction from "../../components/Common/ConfirmAction"
import { get, isString, isEmpty } from "lodash"
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    ConfirmAction,
    BasePage,
    InvoiceForm
  },
  data() {
    return {
      isLoading: true,
      confirmFinalize: false,
      confirmDeleteDraft: false,
      invoice: {}
    }
  },
  methods: {
    ...mapActions([ 'getInvoice', 'finalizeInvoice', 'deleteInvoice' ]),
    _isEmpty: val => isEmpty(val),
    async confirmedDeleteDraft() {
      const payload = {
        id: this.invoice.id
      }

      this.isLoading = true
      await this.deleteInvoice(payload)
        .then(() => {
          this.$router.push({ name: 'customer-detail', params: { id: this.invoice.customer.id } })
        })
      this.isLoading = false

    },
    async confirmedFinalize() {
      const payload = {
        id: this.invoice.id
      }

      this.isLoading = true
      await this.finalizeInvoice(payload)
        .then(() => {
          this.$router.push({ name: 'customer-detail', params: { id: this.invoice.customer.id } })
        })
      this.isLoading = false

    },
    isManualDraft() {
      return this.invoice.billing_reason === 'manual'
        && this.invoice.status === 'draft'
    },
    isPaid() {
      return this.invoice.status === 'paid'
    }
  },
  async mounted() {
    if (this.$route.params.id) {
      const payload = {
        _reload: true,
        expand: [ 'customer', 'total_tax_amounts.tax_rate' ], // This expand customer is not working right now on stripes API
        id: this.$route.params.id
      }

      this.isLoading = true
      const invoice = await this.getInvoice(payload)

      if (invoice) {
        /**
         * !! Important !!
         * Only draft invoices can be edited by Stripe.
         * If the status is not draft, the user must be redirected elsewhere
         */
        if (invoice.status !== 'draft') {
          this.$router.push({ name: 'invoice-detail', params: { id: invoice.id } })
        } else {
          this.invoice = { ...invoice }
        }
      }

      this.isLoading = false
    }
  },
}
</script>
